import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types';
import { DealEventLogTab } from '@dealstack/frontend/app/pages/Project/DealEventLog/DealEventLog.types.ts';

export const asEnumValue = <T extends string>(
	values: T[],
	value: string | null | undefined
): T | undefined => values.find((candidate) => candidate === value);

export const parseDealEventLogTab = (value: string | null): DealEventLogTab | undefined =>
	asEnumValue(Object.values(DealEventLogTab), value);

export const getDealEventLogTabs = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
): MantineTabProps<DealEventLogTab>[] => [
	{
		value: DealEventLogTab.ALL_EVENTS,
		label: tCapManage('deal_event_log.tab.all_events'),
		testId: 'deal-event-log-tab-all-events',
	},
	{
		value: DealEventLogTab.INVESTOR_ACTIVITY,
		label: tCapManage('deal_event_log.tab.investor_activity'),
		testId: 'deal-event-log-tab-investor-activity',
	},
	{
		value: DealEventLogTab.CAPITAL_EVENTS,
		label: tCapManage('deal_event_log.tab.capital_events'),
		testId: 'deal-event-log-tab-capital-events',
	},
	{
		value: DealEventLogTab.TEAM_AND_ACCESS,
		label: tCapManage('deal_event_log.tab.team_and_access'),
		testId: 'deal-event-log-tab-team-and-access',
	},
	{
		value: DealEventLogTab.MESSAGING,
		label: tCapManage('deal_event_log.tab.messaging'),
		testId: 'deal-event-log-tab-messaging',
	},
];
